import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useInstituteService } from '../../../../apis/institute/useInstituteService';
import {
  IFeeStructureParams,
  IFeeStructureResponse,
} from '../../../../apis/institute/institute.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getFeeStructureKey = 'get-fee-structure';

export const useFeeStructureHook = (
  params: IFeeStructureParams | null,
  options?: Partial<
    Omit<UseQueryOptions<IFeeStructureResponse, TQueryError>, 'queryKey' | 'queryFn'>
  >
): UseQueryResult<IFeeStructureResponse, TQueryError> => {
  const { getFeeStructure } = useInstituteService();
  return useQuery<IFeeStructureResponse, TQueryError>({
    queryKey: [getFeeStructureKey, params?.grade, params?.section, params?.category],
    queryFn: () => getFeeStructure(params!),
    ...options,
  });
};
